/**
 * useGetMySpinWheelConfigId — Resolve which spin wheel config the current user spins
 *
 * GET /gamification-models/:id/my-spin-wheel-config-id
 * Returns the FuelUpSpinWheelConfig id the authenticated user is actually
 * routed to (prize-restricted users get the digital-only global wheel). The
 * renderer feeds this id into useGetSpinWheelConfig so the wheel drawn on
 * screen matches the wheel the backend spins.
 */
import {useQuery} from "@tanstack/react-query";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import getConfig from "@/utils/getConfig";
import {GamificationApi} from "@devour/client";

export function useGetMySpinWheelConfigId(gamificationModelId?: string) {
    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    return useQuery({
        queryKey: ["my-spin-wheel-config-id", gamificationModelId],
        queryFn: () =>
            new GamificationApi(getConfig(fullToken)).getGamificationModelsIdMySpinWheelConfigId({id: gamificationModelId!}),
        staleTime: 5 * 60_000,
        enabled: Boolean(gamificationModelId && fullToken),
    });
}
